'use strict';

var React = require('react');

var SvgCollectionReferenceMinor = function SvgCollectionReferenceMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.169 3a3.75 3.75 0 0 0-2.652 1.098l-3.883 3.883a2.75 2.75 0 0 0 0 3.89l2.672 2.672a2.5 2.5 0 0 0 3.536 0l4.206-4.206a3.25 3.25 0 0 0 .952-2.298v-2.289a2.75 2.75 0 0 0-2.75-2.75h-2.081Zm-1.591 2.159a2.25 2.25 0 0 1 1.59-.659h2.082c.69 0 1.25.56 1.25 1.25v2.289c0 .464-.184.909-.513 1.237l-4.206 4.206a1 1 0 0 1-1.414 0l-2.672-2.672a1.25 1.25 0 0 1 0-1.768l3.883-3.883Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.25a.75.75 0 0 0-1.5 0v2.964c0 .465-.184.91-.513 1.238l-.017.018a.75.75 0 1 0 1.06 1.06l.018-.017a3.25 3.25 0 0 0 .952-2.299v-2.964Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.53 16.47a.75.75 0 0 1-1.06 1.06l-2.22-2.22v1.19a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75h3a.75.75 0 1 1 0 1.5h-1.19l2.22 2.22Z"
  }));
};
SvgCollectionReferenceMinor.displayName = "CollectionReferenceMinor";

exports.SvgCollectionReferenceMinor = SvgCollectionReferenceMinor;
